var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      attrs: { "no-body": "", "header-tag": "header", "footer-tag": "footer" }
    },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "total-count" }, [
          _vm._v("\n      " + _vm._s(_vm.totalRows) + "\n      "),
          _c("span", { staticClass: "label" }, [_vm._v("Samples found")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-box", class: { active: _vm.filter } },
          [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c(
                    "div",
                    { staticClass: "input-group-text" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "search", "fixed-width": "" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("b-form-input", {
                  attrs: {
                    type: "text",
                    placeholder: "Find a sample by keyword..."
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "clear-search",
                    on: {
                      click: function($event) {
                        return _vm.clearSearch()
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon",
                      attrs: { icon: "times-circle", "fixed-width": "" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "b-card-body",
        [
          _c(
            "div",
            {
              staticClass:
                "form-inline per-page-selection d-flex align-items-center float-left"
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.pageOptions },
                on: { change: _vm.changePageSize },
                model: {
                  value: _vm.perPage,
                  callback: function($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2 per-page-label" }, [
                _vm._v("Samples Per Page")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "float-right" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.selectSamplesColumnModal",
                    modifiers: { selectSamplesColumnModal: true }
                  }
                ],
                staticClass: "btn btn-sm btn-outline-secondary"
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "cog" }
                }),
                _vm._v("Column Settings\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.totalRows < 1000 && _vm.totalRows > 0
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-secondary ml-2",
                    on: { click: _vm.csvDownload }
                  },
                  [
                    !_vm.downloading
                      ? _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "file-export" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.downloading
                      ? _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "spinner", spin: "" }
                        })
                      : _vm._e(),
                    _vm._v("Export CSV\n      ")
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "selectSamplesColumnModal",
              attrs: {
                id: "selectSamplesColumnModal",
                size: "sm",
                centered: "",
                title: "Column Settings",
                "button-size": "sm",
                "cancel-variant": "outline-secondary"
              }
            },
            [
              _c("p", { staticClass: "help-text" }, [
                _vm._v("Select which table columns you want displayed.")
              ]),
              _vm._v(" "),
              _c(
                "b-form-checkbox-group",
                {
                  attrs: { stacked: "" },
                  model: {
                    value: _vm.selectedCheckboxes,
                    callback: function($$v) {
                      _vm.selectedCheckboxes = $$v
                    },
                    expression: "selectedCheckboxes"
                  }
                },
                _vm._l(_vm.fields, function(field) {
                  return _c(
                    "b-form-checkbox",
                    {
                      key: field.key,
                      attrs: { name: "columnselect", value: field.key }
                    },
                    [_vm._v(_vm._s(field.label))]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.applyColumnSettings }
                  },
                  [_vm._v("Save Settings")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v("Cancel")]
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-table",
        {
          ref: "samplesTable",
          attrs: {
            "show-empty": "",
            striped: "",
            responsive: "",
            busy: _vm.loading,
            "sort-by": _vm.sortBy,
            "sort-desc": _vm.sortDesc,
            items: _vm.doSamplesSearch,
            fields: _vm.fields,
            "current-page": _vm.currentPage,
            "per-page": _vm.perPage,
            filter: _vm.filter,
            "empty-text": "There are no samples to display"
          },
          on: {
            "update:busy": function($event) {
              _vm.loading = $event
            },
            "update:sortBy": function($event) {
              _vm.sortBy = $event
            },
            "update:sort-by": function($event) {
              _vm.sortBy = $event
            },
            "update:sortDesc": function($event) {
              _vm.sortDesc = $event
            },
            "update:sort-desc": function($event) {
              _vm.sortDesc = $event
            },
            filtered: _vm.onFiltered
          },
          scopedSlots: _vm._u([
            {
              key: "top-row",
              fn: function(data) {
                return _vm._l(data.fields, function(field) {
                  return _c(
                    "td",
                    { key: field.filterKey, class: field.tdClass },
                    [
                      field.filterType == "text"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters[field.filterKey],
                                expression: "filters[field.filterKey]"
                              }
                            ],
                            staticClass: "form-control form-control-sm",
                            attrs: { type: "text" },
                            domProps: { value: _vm.filters[field.filterKey] },
                            on: {
                              keyup: function($event) {
                                return _vm.updateColumnFilters()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filters,
                                  field.filterKey,
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      field.filterType == "date"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters[field.filterKey],
                                expression: "filters[field.filterKey]"
                              }
                            ],
                            staticClass: "form-control form-control-sm",
                            attrs: { type: "date" },
                            domProps: { value: _vm.filters[field.filterKey] },
                            on: {
                              change: function($event) {
                                return _vm.updateColumnFilters()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filters,
                                  field.filterKey,
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      field.filterType == "date-range"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters[field.filterKey][0],
                                expression: "filters[field.filterKey][0]"
                              }
                            ],
                            staticClass: "form-control form-control-sm",
                            staticStyle: { width: "90%" },
                            attrs: { type: "date" },
                            domProps: {
                              value: _vm.filters[field.filterKey][0]
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateColumnFilters()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filters[field.filterKey],
                                  0,
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      field.filterType == "date-range"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters[field.filterKey][1],
                                expression: "filters[field.filterKey][1]"
                              }
                            ],
                            staticClass: "form-control form-control-sm",
                            staticStyle: { width: "90%" },
                            attrs: { type: "date" },
                            domProps: {
                              value: _vm.filters[field.filterKey][1]
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateColumnFilters()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filters[field.filterKey],
                                  1,
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                })
              }
            },
            {
              key: "labSampleReference",
              fn: function(data) {
                return [
                  _vm.jobId === "all"
                    ? _c(
                        "router-link",
                        {
                          attrs: {
                            tag: "a",
                            to: "/jobs/" + data.item.job.jobId
                          }
                        },
                        [
                          _c(
                            "strong",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(data.item.labSampleReference) +
                                  "\n          "
                              ),
                              _c("font-awesome-icon", {
                                staticClass: "icon",
                                attrs: {
                                  icon: "angle-right",
                                  "fixed-width": ""
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _c("span", [_vm._v(_vm._s(data.item.labSampleReference))])
                ]
              }
            },
            {
              key: "clientSampleReference",
              fn: function(data) {
                return [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "a",
                        to:
                          "/jobs/" +
                          data.item.job.jobId +
                          "/samples/" +
                          data.item.sampleId
                      }
                    },
                    [
                      _c(
                        "strong",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(data.item.clientSampleReference) +
                              "\n          "
                          ),
                          _c("font-awesome-icon", {
                            staticClass: "icon",
                            attrs: { icon: "angle-right", "fixed-width": "" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }
            },
            {
              key: "registeredDateTime",
              fn: function(data) {
                return [
                  data.item.job.registeredDateTime != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              data.item.job.registeredDateTime,
                              "D MMM YYYY"
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ]
              }
            },
            {
              key: "sampleDate",
              fn: function(data) {
                return [
                  data.item.sampleDate != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(data.item.sampleDate, "D MMM YYYY")
                          )
                        )
                      ])
                    : _vm._e()
                ]
              }
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass: "text-center text-danger my-2",
              attrs: { slot: "table-busy" },
              slot: "table-busy"
            },
            [
              _c("b-spinner", {
                staticClass: "align-middle",
                attrs: { variant: "primary" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-between" },
          [
            _c("span", [
              _vm._v(
                "Page " +
                  _vm._s(_vm.currentPage) +
                  " of " +
                  _vm._s(_vm.totalPages)
              )
            ]),
            _vm._v(" "),
            _c("b-pagination", {
              attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
              model: {
                value: _vm.currentPage,
                callback: function($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage"
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f9dda16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f9dda16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SamplesTable.vue
// module id = PmoH
// module chunks = 1